export const AUTH_STORAGE_KEY = "Authorization";
export const USER_DATA_STORAGE_KEY = "userData";

export const getAuthToken = () => sessionStorage.getItem(AUTH_STORAGE_KEY);

export const setAuthToken = (token: string) => {
  sessionStorage.setItem(AUTH_STORAGE_KEY, token);
};

export const clearAuthSession = () => {
  sessionStorage.removeItem(AUTH_STORAGE_KEY);
  sessionStorage.removeItem(USER_DATA_STORAGE_KEY);
};

export const bootstrapAuthFromUrl = () => {
  const token = new URLSearchParams(window.location.search).get("token");

  if (token) {
    setAuthToken(token);
  }
};
